export const logoutUser = () => {
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("company");
    localStorage.removeItem("selectedcomp");
    localStorage.removeItem("selectedperson");
    localStorage.removeItem("seleteddms");
    localStorage.removeItem("seletedactivity");
    localStorage.removeItem("access");
    localStorage.removeItem("theme");

    // If you're using more keys, add them here
  } catch (error) {
    console.error("Error during logout:", error);
  }
};
